import { inView } from "motion";

const HomeBanner = () => {
  const banners = document.querySelectorAll('.transition-block-class-homebanner');

  banners.forEach(banner => {
    const img = banner.querySelector('img');

    inView(banner, ({ target }) => {
      const addAnimated = () => target.classList.add('animated');

      if (!img || img.complete) {
        addAnimated();
      } else {
        img.addEventListener('load', addAnimated, { once: true });
        img.addEventListener('error', addAnimated, { once: true });
      }

      return () => {
        target.classList.remove('animated');
      };
    });
  });
};

export default HomeBanner;
